import lazyLoad from 'app/shared-components/util/lazyLoad';
import { CRONOFY_CONFIG } from 'app/configs/aws.ts';

const SchedulingApp = lazyLoad(() => import('./SchedulingApp'));

const SchedulingAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  helpConfig: {
    query: 'scheduling',
    tag: 'scheduling',
    title: 'Scheduling'
  },
  routes: CRONOFY_CONFIG.CLIENT_ID ? [
    {
      path: 'apps/scheduling',
      element: <SchedulingApp />,
    },
    {
      path: 'apps/scheduling/availability',
      element: <SchedulingApp />,
      helpConfig: {
        query: 'scheduling availability windows',
        tag: 'scheduling',
        title: 'Availability Windows'
      }
    },
    {
      path: 'apps/scheduling/meeting-types',
      element: <SchedulingApp />,
      helpConfig: {
        query: 'scheduling meeting types',
        tag: 'scheduling',
        title: 'Meeting Types'
      }
    },
    {
      path: 'apps/scheduling/meeting-types/:id',
      element: <SchedulingApp />,
      helpConfig: {
        query: 'scheduling meeting types',
        tag: 'scheduling',
        title: 'Meeting Types'
      }
    },
  ] : [],
};

export default SchedulingAppConfig;